"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var date_fns_1 = require("date-fns");

var core_1 = require("@material-ui/core");

var styles_1 = require("@material-ui/core/styles");

var react_monaco_editor_1 = __importDefault(require("@etclabscore/react-monaco-editor"));

var ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));

var Assignment_1 = __importDefault(require("@material-ui/icons/Assignment"));

require("./cardListItem.css");

var alert_1 = __importDefault(require("../alert/alert"));

var use_dark_mode_1 = __importDefault(require("use-dark-mode"));

var copy_to_clipboard_1 = __importDefault(require("copy-to-clipboard"));

var monaco_add_json_schema_diagnostics_1 = require("@etclabscore/monaco-add-json-schema-diagnostics");

var monaco = __importStar(require("monaco-editor"));

var openrpcDocumentToJSONRPCSchema_1 = __importDefault(require("../../helpers/openrpcDocumentToJSONRPCSchema"));

var openrpcDocumentToJSONRPCSchemaResult_1 = __importDefault(require("../../helpers/openrpcDocumentToJSONRPCSchemaResult"));

var colorTypeMap = {
  // request: "#2196f3",
  // response: "#5c6bc0",
  request: "primary",
  response: "secondary"
};
var useStyles = styles_1.makeStyles(function (theme) {
  return styles_1.createStyles({
    cardHeader: {
      padding: "8px",
      paddingBottom: "0px",
      paddingTop: "0px"
    },
    cardContent: {
      padding: "8px !important"
    }
  });
});

var getCardStyle = function getCardStyle(log) {
  if (log.method.includes("rpc.")) {
    return "call rpc-call";
  }

  if (log.type === "response") {
    if (log.payload.error) {
      return "call response-error";
    }

    return "call response-success";
  }

  return "call request";
};

var CardListItem = function CardListItem(props) {
  var darkMode = use_dark_mode_1.default();
  var callClass = getCardStyle(props.log) + (" " + (darkMode.value ? "dark" : ""));

  var _a = react_1.useState(false),
      open = _a[0],
      setOpen = _a[1];

  var _b = react_1.useState(),
      editor = _b[0],
      setEditor = _b[1];

  var classes = useStyles();
  react_1.useEffect(function () {
    if (editor === undefined) {
      return;
    }

    var s;

    if (props.log.type === "request") {
      s = openrpcDocumentToJSONRPCSchema_1.default(props.openrpcDocument);
    } else {
      s = openrpcDocumentToJSONRPCSchemaResult_1.default(props.log.method, props.openrpcDocument);
    }

    var modelName = props.openrpcDocument && props.openrpcDocument.info ? props.openrpcDocument.info.title : "inspector";
    var modelUriString = "inmemory://" + modelName + "-" + Math.random() + ".json";
    var modelUri = monaco.Uri.parse(modelUriString);
    var model = monaco.editor.createModel(JSON.stringify(props.log.payload, null, 2) || "", "json", modelUri);
    editor.setModel(model);
    monaco_add_json_schema_diagnostics_1.addDiagnostics(modelUri.toString(), s, monaco); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.openrpcDocument, editor]);

  var handleEditorDidMount = function handleEditorDidMount(__, ed) {
    setEditor(ed);
  };

  var handleCopy = function handleCopy(event, value) {
    event.stopPropagation();
    setOpen(true);
    copy_to_clipboard_1.default(JSON.stringify(value, null, 4));
  };

  var handleClose = function handleClose() {
    setOpen(false);
  };

  return react_1.default.createElement(core_1.Box, {
    m: 2,
    key: JSON.stringify(props.log),
    className: ["call-box", "" + (props.log.type === "response" ? "response" : ""), "" + (props.filter.includes(props.log.method) || props.filter.includes("all") ? "" : "hidden")].join(" ")
  }, react_1.default.createElement(core_1.Snackbar, {
    open: open,
    autoHideDuration: 4000,
    onClose: handleClose
  }, react_1.default.createElement(alert_1.default, {
    severity: "success"
  }, "Payload Copied to Clipboard")), react_1.default.createElement(core_1.Card, {
    raised: true,
    className: callClass,
    style: {
      color: "white"
    },
    elevation: 8
  }, react_1.default.createElement(core_1.CardHeader, {
    style: {
      padding: 0
    },
    title: react_1.default.createElement(core_1.Grid, {
      container: true,
      justify: "space-between",
      alignItems: "flex-start",
      direction: "row",
      className: classes.cardHeader
    }, react_1.default.createElement(core_1.Grid, {
      item: true
    }, react_1.default.createElement(core_1.Typography, {
      color: colorTypeMap[props.log.type]
    }, props.log.method)), react_1.default.createElement(core_1.Grid, {
      item: true
    }, props.log.notification && react_1.default.createElement(core_1.Chip, {
      label: "notification",
      style: {
        marginRight: "5px"
      }
    }), react_1.default.createElement(core_1.Chip, {
      label: props.log.type,
      color: colorTypeMap[props.log.type]
    }))),
    subheader: react_1.default.createElement(core_1.Typography, {
      gutterBottom: true,
      color: "textSecondary",
      className: classes.cardHeader
    }, date_fns_1.formatRelative(new Date(), props.log.timestamp))
  }), react_1.default.createElement(core_1.CardContent, {
    className: classes.cardContent
  }, props.log.batchId ? react_1.default.createElement(core_1.Typography, null, "Batch: ", props.log.batchId) : null, react_1.default.createElement(core_1.ExpansionPanel, {
    defaultExpanded: props.open,
    TransitionProps: {
      unmountOnExit: true
    }
  }, react_1.default.createElement(core_1.ExpansionPanelSummary, {
    expandIcon: react_1.default.createElement(ExpandMore_1.default, null)
  }, react_1.default.createElement(core_1.Typography, null, "Payload"), react_1.default.createElement(core_1.Tooltip, {
    title: "Copy to clipboard"
  }, react_1.default.createElement(core_1.IconButton, {
    style: {
      padding: "4px"
    },
    onClick: function onClick(event) {
      return handleCopy(event, props.log.payload);
    }
  }, react_1.default.createElement(Assignment_1.default, {
    style: {
      fontSize: 14
    }
  })))), react_1.default.createElement(core_1.ExpansionPanelDetails, {
    style: {
      margin: 0,
      padding: 0
    }
  }, react_1.default.createElement(react_monaco_editor_1.default, {
    width: "100%",
    height: "250px",
    language: "json",
    value: JSON.stringify(props.log.payload, null, 4),
    editorDidMount: handleEditorDidMount,
    editorOptions: {
      automaticLayout: true,
      useShadows: false,
      glyphMargin: false,
      showFoldingControls: "always",
      // Undocumented see https://github.com/Microsoft/vscode/issues/30795#issuecomment-410998882
      lineDecorationsWidth: 0,
      lineNumbersMinChars: 0,
      minimap: {
        enabled: false
      },
      scrollBeyondLastLine: false,
      lineNumbers: "off",
      fixedOverflowWidgets: true,
      readOnly: true
    }
  }))))));
};

exports.default = react_1.default.memo(CardListItem);